import React, { Component } from 'react';
import {WAVEFORM, PIANO_ROLL} from 'constants/arrangement-modes.js';
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";
import {setIsPlayingMix} from 'actions/index.js';
import {setIsRecordingMix} from 'actions/index.js';
import {setArrangementLooping} from 'actions/index.js';
import {setPianoRollCursor} from 'actions/index.js';
import {
    setArrangementBottomMode,
    setArrangementCursorStep,
    setShowPianoRoll} from 'actions/index.js';
import {setArrangementMouseX} from 'actions/index.js';
import {setProjectAutomationMode} from 'actions/index.js';
import {PLAY_MIX_BUTTON} from 'constants/contextual-help.js';
import {ARRANGEMENT_LOOP_BUTTON} from 'constants/contextual-help.js';
import {RECORD_MIX_BUTTON} from 'constants/contextual-help.js';
import {AUTOMATION_BUTTON} from 'constants/contextual-help.js';
import {TRACK_PIANO_ROLL_BUTTON} from 'constants/contextual-help.js';
import {PLAY, RECORD} from 'constants/automation-modes.js';

class ToolbarMixButtons extends Component {
    onPlayMixClicked(e) {
        this.props.setIsPlayingMix(!(this.props.isPlaying));
        this.props.sequencerEngine.schedulePlay();
        document.activeElement.blur()
    }

    onClickRecordMixButton() {
        let recording = this.props.isRecording || this.props.isRecordingMix;
        this.props.setIsRecordingMix(!recording);
        this.props.sequencerEngine.recording(!recording);
    }

    onClickStop() {
        this.props.sequencerEngine.stop();
        this.props.sequencerEngine.seekToTrackStep(0);
        this.props.setPianoRollCursor(undefined);
        this.props.setArrangementMouseX(undefined);
        this.props.setArrangementCursorStep(0);
    }

    getPianoIcon() {
        return "/piano-icon.png";
    }

    getPianoClass() {
        return this.props.showPianoRoll &&
            this.props.bottomMode === PIANO_ROLL
            ? "piano-roll-button show" : "piano-roll-button";
    }

    onClickPianoRoll() {
        if (this.props.showPianoRoll && this.props.bottomMode === WAVEFORM) {
            this.props.setArrangementBottomMode(PIANO_ROLL);
            return;
        }
        this.props.setArrangementBottomMode(PIANO_ROLL);
        this.props.setShowPianoRoll(!this.props.showPianoRoll);
    }

    render() {
        let playClassName = "playpause ";
        if (this.props.playScheduled) {
            playClassName += " flashit";
        }
        return (
            <div className="mix-buttons">
              <div
                onMouseOver={() => this.props.setContextualHelp(PLAY_MIX_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                className={playClassName}>
                <input
                  onChange={(e) => this.onPlayMixClicked(e)}
                  checked={!this.props.isPlaying}
                  type="checkbox" value={!this.props.isPlaying}
                  id={"playpause"}
                  name="check">
                </input>
                <label
                  className={this.props.isPlaying && this.props.isPlayingMix ? 'mix' : ''}
                  htmlFor={"playpause"}
                  tabIndex={1}>
                </label>
              </div>
              <div
                onClick={() => this.onClickStop()}
                className="stop-button"></div>
              <div
                onMouseOver={() => this.props.setContextualHelp(RECORD_MIX_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClick={() => this.onClickRecordMixButton()}
                className={this.props.isRecording || this.props.isRecordingMix ? "recording-dot" : "not-recording-dot"}>
              </div>
                <img
                   onClick={() => this.onClickPianoRoll()}
                   onMouseOver={() => this.props.setContextualHelp(TRACK_PIANO_ROLL_BUTTON)}
                   onMouseLeave={() => this.props.setContextualHelp(undefined)}
                   className={this.getPianoClass()}
                   src={this.getPianoIcon()}/>
                 <img
                   onMouseOver={() => this.props.setContextualHelp(ARRANGEMENT_LOOP_BUTTON)}
                   onMouseLeave={() => this.props.setContextualHelp(undefined)}
                   onClick={() => this.onClickLooping()}
                   className={"loop-icon"}
                   src={this.getLoopIcon()}/>
            </div>
        ); 
    }

    getLoopIcon() {
        return this.props.looping ? "/arrow-loop-looping.png" : "/arrow-loop.png";
    }

    onClickLooping() {
        this.props.sequencerEngine
            .restartAllMixes(!this.props.looping);
        this.props.setLooping(!this.props.looping);
    }

    getLoopClass() {
        return this.props.looping ? "loop-icon looping" : "loop-icon";
    }

    onClickAutomationMode() {
        if (this.props.automationMode === PLAY) {
            this.props.setProjectAutomationMode(RECORD);
        } else if (this.props.automationMode === RECORD) {
            this.props.setProjectAutomationMode(PLAY);
        }
    }

    getAutomationIcon() {
        return this.props.automationMode === RECORD ?
            '/automation-icon-enabled.png' : '/automation-icon-disabled.png';

    }
}

const mapDispatchToProps = dispatch => {
    return {
        setShowPianoRoll: show => dispatch(setShowPianoRoll(show)),
        setIsPlayingMix: isPlayingMix => dispatch(setIsPlayingMix(isPlayingMix)),
        setIsRecordingMix: isRecordingMix => dispatch(setIsRecordingMix(isRecordingMix)),
        setProjectAutomationMode: mode=> dispatch(setProjectAutomationMode(mode)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setLooping: (looping) => dispatch(setArrangementLooping(looping)),
        setArrangementMouseX: (x) => dispatch(setArrangementMouseX(x)),
        setArrangementBottomMode: mode => dispatch(setArrangementBottomMode(mode)),
        setArrangementCursorStep: step => dispatch(setArrangementCursorStep(step)),
        setPianoRollCursor: step => dispatch(setPianoRollCursor(step)),
    };
};

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    let isPlaying = state.sequencer.isPlaying[id] || 0;
        
    return {
        isRecordingMix: window.installation ? state.sequencer.isRecording : state.mix.isRecordingMix,
        isRecording: state.sequencer.isRecording,
        isPlayingMix: state.mix.isPlayingMix,
        isPlaying: isPlaying,
        showPianoRoll: state.sequencer.showPianoRoll,
        automationMode: state.sequencer.automationMode,
        playScheduled: state.clock.playScheduled,
        looping: state.arrangement.looping,
        bottomMode: state.arrangement.bottomMode
   }
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarMixButtons);
